export const TZ_LOCATIONS = {
  "Arusha": ["Arusha CC", "Arusha DC", "Karatu", "Longido", "Meru", "Monduli", "Ngorongoro"],
  "Dar es Salaam": ["Ilala", "Kinondoni", "Kigamboni", "Temeke", "Ubungo"],
  "Dodoma": ["Bahi", "Chamwino", "Chemba", "Dodoma CC", "Kondoa", "Kongwa", "Mpwapwa"],
  "Geita": ["Bukombe", "Chato", "Geita TC", "Mbogwe", "Nyang'hwale"],
  "Iringa": ["Iringa DC", "Iringa MC", "Kilolo", "Mafinga TC", "Mufindi"],
  "Kagera": ["Biharamulo", "Bukoba DC", "Bukoba MC", "Karagwe", "Kyerwa", "Missenyi", "Muleba", "Ngara"],
  "Katavi": ["Mlele", "Mpanda DC", "Mpanda MC", "Tanganyika"],
  "Kigoma": ["Buhigwe", "Kakonko", "Kasulu DC", "Kasulu TC", "Kibondo", "Kigoma DC", "Kigoma Ujiji MC", "Uvinza"],
  "Kilimanjaro": ["Hai", "Moshi DC", "Moshi MC", "Mwanga", "Rombo", "Same", "Siha"],
  "Lindi": ["Kilwa", "Lindi DC", "Lindi MC", "Liwale", "Nachingwea", "Ruangwa"],
  "Manyara": ["Babati DC", "Babati TC", "Hanang", "Kiteto", "Mbulu", "Simanjiro"],
  "Mara": ["Bunda DC", "Bunda TC", "Butiama", "Musoma DC", "Musoma MC", "Rorya", "Serengeti", "Tarime DC", "Tarime TC"],
  "Mbeya": ["Busokelo", "Chunya", "Kyela", "Mbarali", "Mbeya CC", "Mbeya DC", "Rungwe"],
  "Morogoro": ["Gairo", "Ifakara TC", "Kilombero", "Kilosa", "Morogoro DC", "Morogoro MC", "Mvomero", "Ulanga"],
  "Mtwara": ["Masasi DC", "Masasi TC", "Mtwara DC", "Mtwara MC", "Nanyumbu", "Newala DC", "Newala TC", "Tandahimba"],
  "Mwanza": ["Ilemela", "Kwimba", "Magu", "Misungwi", "Nyamagana", "Sengerema", "Ukerewe"],
  "Njombe": ["Ludewa", "Makambako TC", "Makete", "Njombe DC", "Njombe TC", "Wanging'ombe"],
  "Pwani": ["Bagamoyo", "Kibaha DC", "Kibaha TC", "Kibiti", "Kisarawe", "Mafia", "Mkuranga", "Rufiji"],
  "Rukwa": ["Kalambo", "Nkasi", "Sumbawanga DC", "Sumbawanga MC"],
  "Ruvuma": ["Madaba", "Mbinga DC", "Mbinga TC", "Namtumbo", "Nyasa", "Songea DC", "Songea MC", "Tunduru"],
  "Shinyanga": ["Kahama MC", "Kahama TC", "Kishapu", "Shinyanga DC", "Shinyanga MC"],
  "Simiyu": ["Bariadi DC", "Bariadi TC", "Busega", "Itilima", "Maswa", "Meatu"],
  "Singida": ["Ikungi", "Iramba", "Manyoni", "Mkalama", "Singida DC", "Singida MC"],
  "Songwe": ["Ileje", "Mbozi", "Momba", "Songwe", "Tunduma TC"],
  "Tabora": ["Igunga", "Kaliua", "Nzega DC", "Nzega TC", "Sikonge", "Tabora MC", "Urambo", "Uyui"],
  "Tanga": ["Bumbuli", "Handeni DC", "Handeni TC", "Kilindi", "Korogwe DC", "Korogwe TC", "Lushoto", "Mkinga", "Muheza", "Pangani", "Tanga CC"],
  "Unguja North": ["Kaskazini A", "Kaskazini B"],
  "Unguja South": ["Kati", "Kusini"],
  "Urban West": ["Magharibi", "Mjini"],
  "Pemba North": ["Micheweni", "Wete"],
  "Pemba South": ["Chake Chake", "Mkoani"],
};

export const REGIONS = Object.keys(TZ_LOCATIONS);
export const AGE_GROUPS = ["UTOTO MT.", "VIWAWA", "UWAKA", "WAWATA", "WAZEE"];
export const EVENT_OPTIONS = [
  "BAPTISM",
  "CONFIRMATION",
  "MARRIAGE",
  "FUNERAL_GROUP",
  "CHOIR",
  "YOUTH_GROUP",
  "WOMEN_GROUP",
  "MEN_GROUP",
  "NONE",
];